import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import * as actions from '../../actions'
import { Abandono0, Abandono1 } from './steps'
import { FORM_ABANDONO } from '../../../../config/forms'
import { INTERVALO_CORTO } from '../../../../config/settings'
import StatusModal from
  '../../../Forms/SharedComponents/containers/StatusModal'
import StatusToast from
  '../../../Forms/SharedComponents/containers/StatusToast'
import { ToastContainer } from 'react-toastify'

const selector = formValueSelector(FORM_ABANDONO)

class Abandono extends Component {
  constructor (props) {
    super(props)
    this.nextStep = this.nextStep.bind(this)
    this.prevStep = this.prevStep.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  nextStep () {
    const {
      verificarAbandono,
      abandonoStep,
      numero
    } = this.props

    if (abandonoStep === 0) {
      verificarAbandono(numero)
    }
  }

  prevStep () {
    this.props.abandonoPrevStep()
  }

  handleSubmit () {
    this.props.abandonarCpa(this.props.destroy)
  }

  render () {
    const {
      abandonoStep,
      show,
      showMsgToast,
      abandonoSaveResponse
    } = this.props

    return (
      <div className='camiones-abandono-container'>
        <StatusModal
          show={show}
          onClick={this.props.hideNoAbandonable}
          errorMessage={abandonoSaveResponse}
        />
        <h2>Abandono de CPA</h2>
        {abandonoStep === 0 && <Abandono0 onSubmit={this.nextStep} />}
        {abandonoStep === 1 &&
          <Abandono1 onSubmit={this.handleSubmit} onPrev={this.prevStep} />}
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <div>
          <StatusToast
            show={showMsgToast}
            title={'Atención'}
            message={'Abandonada exitosamente!'}
            onClose={this.props.hideToast}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    numero: selector(state, 'numero'),
    abandonoStep: state.camionesIngreso.abandonoStep,
    show: state.camionesIngreso.abandonoShowSaveModal,
    showMsgToast: state.camionesIngreso.showMsgToast,
    abandonoSaveResponse: state.camionesIngreso.abandonoSaveResponse
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({ form: FORM_ABANDONO })(Abandono)
)
